uniform float u_time;
void main() {
    float x = gl_FragCoord.x;
    float y = gl_FragCoord.y;
    //gl_FragColor = vec4(1.0, 0.5, 0.5, 1.0);
    gl_FragColor = vec4(abs(sin(x))/0.5, abs(cos(y))/0.5, 0.0, 1.0);
    //gl_FragColor = vec4(abs(cos(u_time)), abs(sin(u_time)), 0.0, 1.0);
}
